import {getAnnualMeeting} from '@/http/api'

export default {
  namespaced: true,
  state: {
    activityInfo: {
      votingActivityId: '',
      votingActivityName: '',
      votingTimeStart: '',
      votingTimeEnd: '',
      activityAddress: '',
      activityAddressLat: '',
      activityAddressLng: '',
      activityArrangeList: [],
      votingDetails: ''
    }
  },
  getters: {
    activityId: state => state.activityInfo.votingActivityId,
    timeStart: state => state.activityInfo.votingTimeStart,
    timeEnd: state => state.activityInfo.votingTimeEnd
  },
  mutations: {
    SET_INFO: (state, data) => {
      state.activityInfo = {
        ...state.activityInfo,
        ...data
      }
    }
  },
  actions: {
    getAnnualMeeting({commit}) {
      return new Promise(resolve => {
        getAnnualMeeting().then(res => {
          if (res.result === 'SUCCEED') {
            commit('SET_INFO', res.data)
            resolve()
          }
        })
      })
    }
  }
}
